import { render } from "./Identification.vue?vue&type=template&id=1b5d24e6&ts=true"
import script from "./Identification.vue?vue&type=script&lang=ts"
export * from "./Identification.vue?vue&type=script&lang=ts"

import "./Identification.vue?vue&type=style&index=0&id=1b5d24e6&lang=css"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__